import { render, staticRenderFns } from "./ExhibitionMain.vue?vue&type=template&id=700be1a1&"
import script from "./ExhibitionMain.vue?vue&type=script&lang=js&"
export * from "./ExhibitionMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports